import { render, staticRenderFns } from "./topNotice.vue?vue&type=template&id=99d81a2c&scoped=true"
import script from "./topNotice.vue?vue&type=script&lang=js"
export * from "./topNotice.vue?vue&type=script&lang=js"
import style0 from "./topNotice.vue?vue&type=style&index=0&id=99d81a2c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99d81a2c",
  null
  
)

export default component.exports